// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2039":"b545c8a42a832fcf","4002":"7761de2aa302e968","4471":"b545c8a42a832fcf","7913":"7e7061781534e9f8","8389":"b545c8a42a832fcf"}[chunkId] + ".css";
};